import React from 'react';

const SvgShare = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    {...props}
  >
    <path
      d="M11 10.46C10.2935 10.46 9.64416 10.7043 9.13156 11.1129L5.92887 9.11124C6.02372 8.68222 6.02372 8.23767 5.92887 7.80865L9.13156 5.80696C9.64416 6.21562 10.2935 6.45996 11 6.45996C12.6568 6.45996 14 5.1168 14 3.45996C14 1.80312 12.6568 0.459961 11 0.459961C9.34316 0.459961 8 1.80312 8 3.45996C8 3.68365 8.02469 3.90152 8.07113 4.11124L4.86844 6.11293C4.35584 5.7043 3.7065 5.45996 3 5.45996C1.34316 5.45996 0 6.80312 0 8.45996C0 10.1168 1.34316 11.46 3 11.46C3.7065 11.46 4.35584 11.2156 4.86844 10.807L8.07113 12.8087C8.02379 13.0225 7.99994 13.2409 8 13.46C8 15.1168 9.34316 16.46 11 16.46C12.6568 16.46 14 15.1168 14 13.46C14 11.8031 12.6568 10.46 11 10.46Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgShare;
